import Image from 'next/image'
import { LearningOutcome } from 'types/course'

type CourseDetailOutcomeProps = {
  learningOutcome: LearningOutcome
}

export default function CourseDetailOutcome({
  learningOutcome,
}: CourseDetailOutcomeProps) {
  return (
    <div className='px-4 py-6 rounded-xl border border-textcolor flex sm:flex-col items-center gap-6 sm:gap-2'>
      {learningOutcome.imageUrl && (
        <div className='w-16 h-16 relative'>
          <Image
            src={learningOutcome.imageUrl}
            alt={learningOutcome.title}
            layout='fill'
          />
        </div>
      )}

      <div className='sm:text-center text-base font-medium leading-snug flex-grow'>
        {learningOutcome.title}
      </div>
    </div>
  )
}
